import { Component } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { FooterComponent } from './core/layout/footer.component';
import { MenuComponent } from './shared/menu/menu.component';
import { PushNotificationsService } from './shared/service/push-notifications.service';
import { Store } from '@ngxs/store';
import { AuthActions } from './shared/state/auth.actions';
import { NgxGoogleAnalyticsModule } from '@hakimio/ngx-google-analytics';
import { environment } from '../environments/environment.development';
import { NgxNotifier } from 'ngx-notifier';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, MenuComponent, NgxGoogleAnalyticsModule, NgxNotifier],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  // BUG revisar porque se carga el home estando en la pantalla de producto
  title = 'etoyrepublic__a18';
  constructor(
    // private sharedService: PushNotificationsService,
    private activeRoute: ActivatedRoute,
    private store: Store,
  ) { }
  ngOnInit(): void {
    // 
    // this.store.dispatch(new AuthActions.Reset());
    // 
    // this.sharedService.subscribeToNotifications();
    // this.sharedService.subscribeMessage();
    // if (environment.closed) {
    //   window.location.href = 'closed';
    // })
  }
  ngOnDestroy() {
    // this.sharedService.unsubscribeFromPushNotifications();
  }
  //  se calcula el iva
  // ((total * 0.036) + (total * 0.0457)) * 0.16
}
